import QrCode from "react-qr-code"
export const QRCode=({...props})=>{
    return(
        <QrCode {...props} value="https://home.izichange.com/download_app" />
    )
}